import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const Layout = () => (
  <Container className={"container-mw-sm layout--narrow"}>
    <Outlet />
  </Container>
);

export default Layout;
